import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../_common/Form/Buttons/Button';
import classes from './statusForm.module.scss';
import Select from '../../../../_common/Form/Selects/Select/Select';

const cancelOptions = [
  'Change in Therapy',
  'Therapy Completion',
  'Change in Doctor',
  'Adverse Reaction',
  'Patient Deceased',
  'Duplicate Script',
  'Unaffordable',
  'Pharmacy Transfer',
  'Doctor Decision',
  'Transfer to Hub',
  'Patient Decision',
  'Patient Hospitalized',
  'Dose Change',
  'Manufacturer Free Drug Program',
  'Payor Restriction',
  'Unable to Reach Patient',
  'Unable to Reach Physician',
  'Other',
];

const CancelledStatus = ({ changeStatus, defaultReason }) => {
  const [cancelReason, setCancelReason] = useState(defaultReason || '');

  const setStatus = () => {
    changeStatus({ status: 'Cancelled', cancelReason });
  };

  return (
    <div className={classes.status_wrapper}>
      <div className={classes.cancel_wrapper}>
        <Select
          labelBG="#f6f8fa"
          label="Reason for Cancelling"
          options={cancelOptions}
          onChange={(option) => setCancelReason(option)}
          currentOption={cancelReason}
          hideClearButton
        />

        <div className={classes.btns_wrapper}>
          <Button
            // className={classes.max_content}
            title="Approve"
            reverseColor
            onClick={setStatus}
          />
        </div>
      </div>
    </div>
  );
};

CancelledStatus.propTypes = {
  changeStatus: PropTypes.func.isRequired,
  defaultReason: PropTypes.string.isRequired,
};

export default CancelledStatus;
